import axios from 'axios'
import * as Config from '../../config'

const state = {
    users: {
        current_page: 1,
        data: [],
    },
    user: {},
}

const actions = {

    loadUsers({ commit, dispatch }, params) {
        commit('LOAD_USERS')

        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'users', { params })
                .then(
                    response => {
                        if (response.data.code !== 500) {
                            commit('LOAD_USERS_OK', response.data.users)
                            resolve()
                        } else {
                            commit('LOAD_USERS_FAIL')
                            reject()
                        }

                    })
                .catch((error) => {
                    console.log(error);
                    commit('LOAD_USERS_FAIL');
                    reject();
                })
        })
    },

    user_sendRecoveryEmail({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'user/send-recovery-email', payload)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response ? error.response.data : error);
                });
        });
    },

    user_deleteByAdmin({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'user/delete-by-admin', payload)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response ? error.response.data : error);
                });
        });
    },


user_getRegistered({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
        // Axios toma el "payload" y lo convierte automáticamente en parámetros de URL
        axios.get(Config.apiPath + 'user/registered', { params: payload })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error.response ? error.response.data : error);
            });
    });
},


    get_user_from_afip_by_cuit({ commit, dispatch }, cuit) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'user/get_from_afip/' + cuit)
                .then(
                    response => {
                        resolve(response.data)
                    })
                .catch(error => {
                    reject(error.response.data)
                })
        })
    },
    get_user_from_afip_by_cuit_for_invoice({ commit, dispatch }, cuit) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'user/get_from_afip_for_invoice/' + cuit)
                .then(
                    response => {
                        resolve(response.data)
                    })
                .catch(error => {
                    reject(error.response.data)
                })
        })
    },
    get_user_from_afip_by_cuit_for_new_mono({ commit, dispatch }, cuit) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'user/get_from_afip_for_new_mono/' + cuit)
                .then(
                    response => {
                        resolve(response.data)
                    })
                .catch(error => {
                    reject(error.response.data)
                })
        })
    },

    loadIndicators({ commit, dispatch }, id) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'user/total_indicators/' + id)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.response.data)
                })
        })
    },

    loadUsersActives({ commit, dispatch }, params) {
        commit('LOAD_USERS')

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'users', { params })
                // axios.get('https://jsonplaceholder.typicode.com/users', {params})
                .then(
                    response => {
                        // if(response.data.code !== 500){
                        //     commit('LOAD_USERS_OK', response.data.users)
                        //     resolve()
                        // } else {
                        //     commit('LOAD_USERS_FAIL')
                        //     reject()
                        // }
                        commit('LOAD_USERS_OK', response.data)

                    })
                .catch((error) => {
                    console.log(error);
                    commit('LOAD_USERS_FAIL');
                    reject();
                })
        })
    },

    // loadUserFind ({commit, dispatch}, id) {
    //   commit('LOAD_USER')
    //
    //   return new Promise((resolve, reject) => {
    //     axios.get(Config.apiPath + 'user/' + id)
    //       .then(
    //         response => {
    //           commit('LOAD_USER_OK', response.data.user)
    //           resolve()
    //         })
    //       .catch(error => {
    //         commit('LOAD_USER_FAIL')
    //         reject(error.response.data)
    //       })
    //   })
    // },

    updateUser({ commit, dispatch }, { id, form }) {
        commit('UPDATE_USER')

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'user/' + id, { _method: 'PUT', ...form })
                .then(
                    response => {
                        commit('UPDATE_USER_OK', response.data.user)
                        resolve()
                    })
                .catch(error => {
                    commit('UPDATE_USER_FAIL')
                    reject(error.response.data)
                })
        })
    },
    loadCity({ commit, dispatch }) {
        //commit('UPDATE_PASSWORD')

        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'user/list/city')
                .then(
                    response => {

                        //commit('UPDATE_PASSWORD_OK', response.data)
                        resolve(response.data)
                    })
                .catch(error => {
                    //commit('UPDATE_PASSWORD_FAIL')
                    reject(error.response.data)
                })
        })
    },
    loadUserPoint({ commit, dispatch }, data) {
        commit('LOAD_USER_POINT')

        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'userpoint/acumfilterby/' + data.idtypepoint + '/' + data.iduser)
                .then(
                    response => {
                        if (response.data.code !== 500) {
                            commit('LOAD_USER_POINT_OK', response.data.data)
                            resolve(response.data.data)
                        } else {
                            commit('LOAD_USER_POINT_FAIL')
                            reject()
                        }

                    })
                .catch(error => {
                    commit('LOAD_USER_POINT_FAIL')
                    reject(error)
                })
        })
    },
    loadGender({ commit, dispatch }) {
        //commit('UPDATE_PASSWORD')

        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'user/list/gender')
                .then(
                    response => {

                        //commit('UPDATE_PASSWORD_OK', response.data)
                        resolve(response.data)
                    })
                .catch(error => {
                    //commit('UPDATE_PASSWORD_FAIL')
                    reject(error.response.data)
                })
        })
    },

    //TODO NEW
    user_getAll({ commit, dispatch }) {
        return new Promise((resolve, reject) => {

            axios.get(Config.apiPath + 'user/list/all')
                .then(
                    response => {
                        //commit('LOAD_PACKAGES',response.data)
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    load_User({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'user/consult/' + form.id)
                .then(
                    response => {
                        //commit('LOAD_PACKAGE', data);
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });

    },
    new_User({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'user/store', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    changeActive_User({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'user/change/active/' + form.id + '/' + form.active)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    changeStatus_User({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'user/change/status/' + form.id + '/' + form.status)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    update_User({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'user/update/' + form.id, form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    verify_wsp_create({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'user/verify-wsp/create', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    verify_wsp_check({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'user/verify-wsp/check', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    verify_cuit({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'user/verify-cuit', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    verify_password_afip({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'user/verify-password-afip', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    user_verifyDni({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'user/verify-dni', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    auto_invoice_13({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mono/auto-invoice-13', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    wsp_pass_recovery({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'user/pass-recovery', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    user_update_afip_password({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'user/update-afip-password', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    user_delete({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'user/delete', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    user_download_apk() {

        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'user/download-apk', {
                    responseType: 'blob' // Indicamos que esperamos una respuesta binaria
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    user_recategorized({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .post(Config.apiPath + 'whatsapp-busisness/user/recategorized', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

}

const mutations = {

    LOAD_USERS_OK(state, users) {
        state.users = users
    },

    LOAD_USER_OK(state, user) {
        state.user = user
    },

    LOAD_USER_POINT_OK(state, user) {
        state.user = user
    },

    UPDATE_USER_OK(state, user) {
        state.user = user
    },

}

export default {
    state,
    actions,
    mutations
}